import { BulkButtonComponents } from "@components/common/faro-table/faro-table-types";
import { LoadingWrapper } from "@context-providers/loading-state-context";
import { TranslateVar } from "@flat-ui";
import { Divider, Stack } from "@mui/material";
import { sphereColorsTransparent } from "@styles/common-colors";
import { CommonStyles, DEFAULT_TEXT_FONT_SIZE } from "@styles/common-styles";
import { ReactNode } from "react";

interface BulkToolbarProps {
  /** Number of rows that is selected in the table */
  numberOfSelectedRows: number;

  /** Total number of rows */
  numberOfRows: number;

  /** Whether data is loading - automatically handles loading state for all action buttons */
  isLoading?: boolean;

  /** Buttons shown in table action bar on the left side */
  sortActions?: ReactNode;

  /** Buttons shown in table action bar on the right side */
  bulkActionsButtons?: BulkButtonComponents;
}

/** Toolbar to show for bulk actions */
export function FaroTableToolbar({
  numberOfSelectedRows,
  numberOfRows,
  bulkActionsButtons,
  sortActions,
  isLoading = false,
}: BulkToolbarProps): JSX.Element {
  return (
    <Stack
      direction="row"
      alignItems="center"
      flexWrap="nowrap"
      sx={{
        height: "54px",
        backgroundColor: sphereColorsTransparent.gray50,
        mt: "12px",
        pl: "20px",
      }}
    >
      <Stack sx={{ flexShrink: 0, minWidth: 0 }}>{sortActions}</Stack>

      {bulkActionsButtons && (
        <Stack
          direction="row"
          alignItems="center"
          flexWrap="nowrap"
          sx={{ flexGrow: 1, justifyContent: "flex-end", minWidth: 0 }}
        >
          <Stack
            direction="row"
            alignItems="center"
            flexWrap="wrap"
            fontSize={DEFAULT_TEXT_FONT_SIZE}
            sx={{ mr: 2 }}
          >
            {!!numberOfSelectedRows && (
              <p>
                <TranslateVar name="numberOfSelectedRows">
                  <b> {numberOfSelectedRows} </b>
                </TranslateVar>
                <b>of</b>
                <TranslateVar name="numberOfRows">
                  <b> {numberOfRows} </b>
                </TranslateVar>
                selected
              </p>
            )}
          </Stack>
          <Stack
            direction="row"
            divider={
              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  borderColor: CommonStyles.Borders.gray200DividerTransparent,
                }}
              />
            }
            sx={{ overflowX: "auto" }}
          >
            {Object.values(bulkActionsButtons).map(
              (bulkActionsButton, index) =>
                bulkActionsButton !== null && (
                  <Stack
                    component="div"
                    key={index}
                    sx={{
                      px: "18px",
                    }}
                  >
                    <LoadingWrapper isLoading={isLoading}>
                      {bulkActionsButton}
                    </LoadingWrapper>
                  </Stack>
                )
            )}
          </Stack>
        </Stack>
      )}
    </Stack>
  );
}
